(function () {
  if (typeof Storage === "undefined") {
    console.warn("Storage is not supported.");
    return;
  }

  // =========================
  // RUN ONLY ON FRAGBUY
  // =========================
  const isFragBuySite = window.location.hostname.includes("fragrancebuy.ca");
  if (!isFragBuySite) return;

  // =========================
  // BASIC BOT CHECK
  // =========================
  const userAgent = navigator.userAgent.toLowerCase();
  const isBot =
    /(bot|crawl|slurp|spider|mediapartners|facebookexternalhit|pinterest|crawler|bingpreview|ahrefs|yandex|baiduspider)/.test(
      userAgent,
    );

  if (isBot) return;

  // =========================
  // PREVENT CROSS-DOMAIN LOOP
  // =========================
  const urlParams = new URLSearchParams(window.location.search);

  if (urlParams.get("redirected") === "true") {
    const url = new URL(window.location.href);
    url.searchParams.delete("redirected");

    window.history.replaceState({}, document.title, url.pathname + url.search);
    return;
  }

  // helper to normalize hostnames
  function normalizeHost(hostname) {
    return hostname.replace(/^www\./, "");
  }

  // =========================
  // USER PREFERRED SITE (note: if user already chose this domain - do not show modal)
  // =========================
  const preferredSite = localStorage.getItem("preferredSite");

  if (
    preferredSite &&
    preferredSite === normalizeHost(window.location.hostname)
  ) {
    return;
  }

  // Prevent showing modal repeatedly in the same session
  if (sessionStorage.getItem("redirectModalDismissed")) return;

  // =========================
  // SHARED US HANDLER
  // =========================
  function handleUSVisitor() {
    const modal = document.getElementById("redirect-modal");
    if (!modal) return;

    const counterEl = modal.querySelector("#redirect-counter");
    const stayBtn = document.getElementById("redirect-confirm");
    const continueBtn = document.getElementById("redirect-cancel");

    let countdown = 20;
    let timer;

    function updateCounter() {
      counterEl.textContent = countdown;
    }

    const TARGET_ORIGIN = "https://fragflex.com";

    function redirectToTargetSite(targetOrigin = TARGET_ORIGIN) {
      const url = new URL(window.location.href);

      url.searchParams.delete("redirected");

      const query = url.searchParams.toString();

      const target = new URL(targetOrigin);
      target.pathname = url.pathname;

      if (query) {
        target.search = `?${query}`;
      }

      target.searchParams.set("redirected", "true");

      window.location.href = target.toString();
    }

    function showModal() {
      modal.classList.remove("hidden");
      requestAnimationFrame(() => modal.classList.add("active"));

      updateCounter();
      timer = setInterval(() => {
        countdown--;
        updateCounter();

        if (countdown <= 0) {
          clearInterval(timer);
          redirectToTargetSite();
        }
      }, 1000);
    }

    function closeModal() {
      modal.classList.remove("active");
      modal.addEventListener(
        "transitionend",
        () => modal.classList.add("hidden"),
        { once: true },
      );
    }

    stayBtn.addEventListener("click", () => {
      clearInterval(timer);
      closeModal();
      sessionStorage.setItem("redirectModalDismissed", "true");
      localStorage.setItem(
        "preferredSite",
        normalizeHost(window.location.hostname),
      );
    });

    continueBtn.addEventListener("click", () => {
      clearInterval(timer);
      redirectToTargetSite();
    });

    showModal();
  }

  GeoCountryCache.getCountry(function (country) {
    if (country === "US") {
      handleUSVisitor();
    }
  });
})();
